import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const getMediaToQualifyDetails = async (id) => {
  const response = await axiosInstance.get(`/medias/${id}/`);
  return response.data;
};

export const useGetMediaToQualifyDetails = (id, options = {}) => {
  const { data, error, isLoading, isError, refetch, isFetching } = useQuery({
    queryKey: ['medias', id],
    queryFn: () => getMediaToQualifyDetails(id),
    enabled: options.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnWindowFocus: false,
  });

  const media = data;

  return {
    media,
    error,
    isLoading,
    isError,
    isFetching,
    refetch,
  };
};
